import React, { ReactChild, ReactChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';

interface FinalizeCardProps {
  isLoading?: boolean;
  icon: IconDefinition | IconProp;
  title: string;
  subheading?: string;
  marginBottom?: string;
  buttonText?: string;
  className?: string;
  children: ReactChild | ReactChildren | ReactNode;
  onClick: () => unknown;
}

const StyledDiv = styled.div<{ marginBottom: string }>`
  max-width: 810px;
  margin-left: auto;
  margin-right: auto;
  padding: ${SPACERS.extraLarge};
  border-radius: ${SPACERS.extraTiny};
  background-color: ${COLORS.grayLightest};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  .title {
    display: flex;
    align-items: center;
    margin-bottom: ${SPACERS.small};
    svg {
      width: ${SPACERS.large};
      height: ${SPACERS.large};
    }
    .card-heading {
      margin-bottom: 0;
      margin-left: ${SPACERS.tiny};
    }
  }
  .subheading {
    margin-bottom: ${SPACERS.small};
    padding-bottom: ${SPACERS.small};
    border-bottom: 1px solid ${COLORS.grayLight};
  }
  .card-content {
    margin-bottom: ${SPACERS.medium};
  }
`;

const FinalizeCard: React.FC<FinalizeCardProps> = ({
  icon,
  title,
  subheading,
  isLoading,
  children,
  className,
  marginBottom = SPACERS.medium,
  buttonText = 'Make changes',
  onClick,
}) => {
  return (
    <StyledDiv marginBottom={marginBottom} className={className}>
      <div className="title">
        <FontAwesomeIcon icon={icon} color={COLORS.blackBase} />
        <TrueImpactText variant="heading" className="card-heading">
          {title}
        </TrueImpactText>
      </div>
      {subheading && (
        <TrueImpactText className="subheading">{subheading}</TrueImpactText>
      )}
      <div className="card-content">{children}</div>
      <TrueImpactButton isLoading={isLoading} onClick={onClick}>
        {buttonText}
      </TrueImpactButton>
    </StyledDiv>
  );
};

export default FinalizeCard;
